module.exports = __webpack_public_path__ + "static/media/country_es.f523573b.webp";